import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { Typography, Button } from '@mui/material';
import './Reviews.css';

const DeleteReview = () => {
  const [reviews, setReviews] = useState([]);
  const reviewTilesRef = useRef([]);

  const deleteReview = async (reviewId) => {
    try {
      await axios.delete(`https://zoomautos.co.uk/api/reviews/${reviewId}`);
      setReviews((prevReviews) => prevReviews.filter((review) => review._id !== reviewId));
    } catch (error) {
      console.error("Error deleting the review:", error);
    }
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/reviews'
          , {
            
          params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
        
        });
        
        setReviews(response.data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };
    fetchReviews();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
          else entry.target.classList.remove('visible');
        });
      },
      { threshold: 0.1 }
    );

    reviewTilesRef.current.forEach((tile) => tile && observer.observe(tile));
    return () => {
      reviewTilesRef.current.forEach((tile) => tile && observer.unobserve(tile));
    };
  }, [reviews]);

  return (

    <div className="reviews-container" style={{marginTop:'100px'}}>
      <h1>Review Delete</h1>
      {reviews.length > 0 ? (
        <div className="reviews-list">
          {reviews.map((review, index) => (
            <div
              key={review._id}
              className="review-tile animate-on-scroll"
              ref={(el) => (reviewTilesRef.current[index] = el)}
            >
              <div className="rating">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className={star <= review.rating ? 'star-filled' : 'star-empty'}>
                    ★
                  </span>
                ))}
              </div>
              <Typography variant="body2" className="review-text">
                {review.feedback}
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={() => deleteReview(review._id)}
              >
                Delete
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <Typography variant="body1" className="no-reviews">No reviews available.</Typography>
      )}
    </div>
  );
};

export default DeleteReview;
